module.exports = __webpack_public_path__ + "img/info-living-cost.d1eb96a5.svg";